// components/ui/AnimatedTabs.jsx
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

const AnimatedTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(null);

  return (
    <div className="flex flex-col w-full">
      {tabs.map((tab, index) => (
        <div key={index} className="border-b last:border-b-0">
          <div
            className="flex items-center justify-between p-4 cursor-pointer"
            onClick={() => setActiveTab(activeTab === index ? null : index)}
          >
            <div className="flex items-center gap-3">
              <span className="font-semibold text-base">
                {tab.title}
              </span>
            </div>
            <motion.div
              animate={{ rotate: activeTab === index ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <Icon icon="lucide:chevron-down" width="20" />
            </motion.div>
          </div>

          <AnimatePresence>
            {activeTab === index && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="overflow-hidden"
              >
                <div className="pt-2 pb-4 px-4">
                  {tab.content}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
};

export default AnimatedTabs;